import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../../pages/home";
import Header from "../header";
import Footer from "../footer";
import BlogPage from "../blog";
import BlogDetails from "../blogdetails";
import { LanguageProvider } from "../languagecontext";
import ScrollToTop from "../ScrollToTop";   
import FAQ from "../faq";
import News from "../news";
import SpecialNews from "../specialnews";
import ServicesAsra from "../service";
import ExpressEntry from "../expressentry";
import BookingForm from "../bookingform";
import BookingIntakeForm from "../bookingintakeform";
import TermsAndConditions from "../termsandconditions";
import ContactUs from "../contactus";
import PrivacyPolicy from "../privacypolicy";
import CheckEligibility from "../checkeligibility";
import AboutUs from "../aboutus";
function AppRouter() {
    return (
        <div className="">
            <Router>
                <LanguageProvider>
                    <Header />
                          <ScrollToTop />
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/blog" element={<BlogPage />} />
                        <Route path="/:slug" element={<BlogDetails />} />
                        <Route path="/faq" element={<FAQ />} />
                        <Route path="/news" element={<News />} />
                        <Route path="/specialnews" element={<SpecialNews />} />
                        <Route path="/service" element={<ServicesAsra />} />
                        <Route path="/servicedetail/:slug" element={<ExpressEntry />} />
                        <Route path="/termsandconditions" element={<TermsAndConditions />} />
                        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
                        <Route path="/contactus" element={<ContactUs />} />
                        <Route path="/checkeligibility" element={<CheckEligibility />} />
                        <Route path="/aboutus" element={<AboutUs />} />
                        <Route path="/bookingform" element={<BookingForm />} />
                        <Route path="/bookingintakeform" element={<BookingIntakeForm />} />
                    </Routes>
                    <Footer />
                </LanguageProvider>

            </Router>
        </div>
    );
}

export default AppRouter;
